import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subject, Observable, EMPTY } from 'rxjs';
import { catchError, filter, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { ContactCardComponent } from '../contact-card/contact-card.component';
import { DateCardComponent } from '../date-card/date-card.component';
import { InfoCardComponent } from '../info-card/info-card.component';
import { TermsCardComponent } from '../term-card/terms-card.component';
import { Ticket, SpecialTicketData } from '../../../../shared/models/ticket';
import { TicketService } from '../../../../services/ticket.service';
import { PassengerTypesComponent } from '../passenger-types/components/passenger-types.component';
import { HeaderComponent } from "../../../../shared/components/header/header.component";
import { PurchaseFooterComponent } from '../purchase-footer/purchase-footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { BackendError, ErrorMessages, ErrorService } from '../../../../services/error-service';
import { ErrorPageComponent } from "../../../error-page/error-page.component";
import { Utility } from '../../../../services/utility/util';
import { PurchaseService } from '../../../../services/purchase.service';

@Component({
  selector: 'app-ticket-page',
  templateUrl: './main-ticket-page.component.html',
  styleUrls: ['./main-ticket-page.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    PassengerTypesComponent,
    ContactCardComponent,
    DateCardComponent,
    InfoCardComponent,
    TermsCardComponent,
    PurchaseFooterComponent,
    HeaderComponent,
    ErrorPageComponent
  ],
})
export class TicketPageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  tickets$!: Observable<Ticket[]>;
  ticketData: SpecialTicketData | null = null;
  localeKey$: Observable<string>;
  error: (ErrorMessages & { operationId?: string }) | null = null;

  constructor(
    private route: ActivatedRoute,
    private ticketService: TicketService,
    private errorService: ErrorService,
    private purchaseService: PurchaseService,
    public utility: Utility
  ) {
    this.tickets$ = this.ticketService.tickets$;
    this.localeKey$ = this.utility.getLocaleKey();
  }

  ngOnInit(): void {
    this.purchaseService.purchaseError$
      .pipe(
        filter(err => err !== null),
        takeUntil(this.destroy$)
      )
      .subscribe(err => {
        this.error = err;
      });

    this.route.paramMap.pipe(
      map(params => params.get('id')),
      filter((id): id is string => !!id),
      switchMap(id => this.ticketService.loadTicketData(id).pipe(
        catchError((err: BackendError) => {
          const messages = this.errorService.getErrorMessages(err.Id);
          this.error = { ...messages, operationId: err.operationId };
          return EMPTY;
        })
      )),
      takeUntil(this.destroy$)
    ).subscribe(ticketData => {
      this.ticketData = ticketData;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}